// PESOCertificate.jsx
import React from "react";

export default function PESOCertificate() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            PESO Certificate
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            PESO Certificate for Petroleum & Explosives Safety
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists businesses in obtaining PESO
            Certificates in compliance with Petroleum and Explosives Safety
            Organization regulations for storage, handling, and manufacturing.
          </p>
          <p className="text-gray-700">
            From technical site assessment and safety documentation to license
            application preparation and authority approvals, the process is
            managed with focus on safety compliance and regulatory requirements.
          </p>
        </div>

        {/* Right: Image (square for consistency - Different image) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/247599/pexels-photo-247599.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="PESO safety compliance and petroleum storage facility"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for PESO Certificate
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps prepare the technical safety and
              compliance documentation required for PESO license approvals for
              petroleum storage, handling, and explosive facilities.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Site layout plans and safety management plans including fire
                  safety, spill containment, and emergency response procedures.
                </li>
                <li>
                  Identity proof of applicant, proprietors, or company
                  directors.
                </li>
                <li>
                  Premises ownership documents including lease agreements,
                  ownership proofs, and municipal approvals for the facility.
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm specializes in PESO compliance with technical expertise
              in petroleum and explosives safety regulations and licensing.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Technical Regulatory Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Deep understanding of Petroleum Act, Explosives Rules, and
                  PESO technical standards for storage, transportation, and
                  manufacturing facilities across industries.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Safety Compliance Focus
                </h3>
                <p className="text-gray-700 text-sm">
                  Specialized support in safety audits, risk assessment
                  documentation, and compliance gap analysis to meet stringent
                  PESO safety requirements.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Handling
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end management from technical documentation and site
                  plan preparation through PESO inspections, license approval,
                  and ongoing compliance advisory.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
